<template>
  <div class="Wiederruftext">
    <p class="has-text-weight-bold smallspacetop is-size-4 is-size-5-mobile">Widerrufsbelehrung</p>
    <p class="has-text-weight-bold is-size-5 is-size-6-mobile">Widerrufsrecht</p>
    <p>
      Sie haben das Recht, binnen vierzehn Tagen ohne Angabe von Gr&uuml;nden
      diesen Vertrag zu widerrufen. Die Widerrufsfrist betr&auml;gt vierzehn
      Tage ab dem Tag des Vertragsabschlusses.
    </p>
    <p class="smallspacetop">
      Um Ihr Widerrufsrecht auszu&uuml;ben, m&uuml;ssen Sie uns (Wilde Pracht - Christian Plöhn & Gunnar Plöhn & Birte Schmidt GbR, Mielberg 4, 24848 Kropp, Deutschland, moin@wilde-pracht.com,
      Telefon: +49 (0) 4624 451 946 3) mittels einer eindeutigen Erkl&auml;rung
      (z. B. ein mit der Post versandter Brief, Telefax oder E-Mail) &uuml;ber
      Ihren Entschluss, diesen Vertrag zu widerrufen, informieren. Sie
      k&ouml;nnen daf&uuml;r das beigef&uuml;gte Muster-Widerrufsformular
      verwenden, das jedoch nicht vorgeschrieben ist.
    </p>
    <p class="smallspacetop">
      Zur Wahrung der Widerrufsfrist reicht es aus, dass Sie die Mitteilung
      &uuml;ber die Aus&uuml;bung des Widerrufsrechts vor Ablauf der
      Widerrufsfrist absenden.
    </p>
    <p class="has-text-weight-bold is-size-5 is-size-6-mobile">Folgen des Widerrufs</p>
    <p>
      Wenn Sie diesen Vertrag widerrufen, haben wir Ihnen alle Zahlungen, die
      wir von Ihnen erhalten haben, einschlie&szlig;lich der Lieferkosten (mit
      Ausnahme der zus&auml;tzlichen Kosten, die sich daraus ergeben, dass Sie
      eine andere Art der Lieferung als die von uns angebotene, g&uuml;nstigste
      Standardlieferung gew&auml;hlt haben), unverz&uuml;glich und
      sp&auml;testens binnen vierzehn Tagen ab dem Tag zur&uuml;ckzuzahlen, an
      dem die Mitteilung &uuml;ber Ihren Widerruf dieses Vertrags bei uns
      eingegangen ist. F&uuml;r diese R&uuml;ckzahlung verwenden wir dasselbe
      Zahlungsmittel, das Sie bei der urspr&uuml;nglichen Transaktion eingesetzt
      haben, es sei denn, mit Ihnen wurde ausdr&uuml;cklich etwas anderes
      vereinbart; in keinem Fall werden Ihnen wegen dieser R&uuml;ckzahlung
      Entgelte berechnet.
    </p>
    <p class="smallspacetop">
      Das Widerrufsrecht erlischt bei einem Vertrag &uuml;ber die Lieferung von
      nicht auf einem k&ouml;rperlichen Datentr&auml;ger befindlichen digitalen
      Inhalten auch dann, wenn wir mit der Ausf&uuml;hrung des Vertrags begonnen
      haben, nachdem Sie ausdr&uuml;cklich zugestimmt haben, dass wir mit der
      Ausf&uuml;hrung des Vertrags vor Ablauf der Widerrufsfrist beginnen, und
      Ihre Kenntnis davon best&auml;tigt haben, dass Sie durch Ihre Zustimmung
      mit Beginn der Ausf&uuml;hrung des Vertrags Ihr Widerrufsrecht verlieren.
    </p>
    <div class="legalleftborder">
      <p class="has-text-weight-bold is-size-5 is-size-6-mobile">Muster-Widerrufsformular</p>
      <p>
        <em>
          (Wenn Sie den Vertrag widerrufen wollen, dann f&uuml;llen Sie bitte
          dieses Formular aus und senden Sie es zur&uuml;ck.)
        </em>
      </p>
      <ul class="smallspacetop">
        <li class="legalli">
          An Wilde Pracht - Christian Plöhn & Gunnar Plöhn & Birte Schmidt GbR,
          Mielberg 4, 24848 Kropp, Deutschland, moin [at] wilde-pracht.com
        </li>
        <li class="legalli">
          Hiermit widerrufe(n) ich/wir (*) den von mir/uns (*) abgeschlossenen
          Vertrag &uuml;ber den Kauf der folgenden
          <br />Waren (*)/die Erbringung der folgenden Dienstleistung (*)
        </li>
        <li class="legalli">Bestellt am (*)/erhalten am (*)</li>
        <li class="legalli">Name des/der Verbraucher(s)</li>
        <li class="legalli">Anschrift des/der Verbraucher(s)</li>
        <li class="legalli">Unterschrift des/der Verbraucher(s) (nur bei Mitteilung auf Papier)</li>
        <li class="legalli">Datum</li>
      </ul>
      <p>
        <em>(*) Unzutreffendes streichen.</em>
      </p>
    </div>
    <p class="smallspacetop">
      <em>
        <a
          title="Widerrufsbelehrung"
          href="https://shop.trustedshops.com/de/rechtstexte/"
          target="_blank"
          rel="noopener"
        >Widerrufsbelehrung</a>
        erstellt mit dem
        <a
          title="Trusted Shops"
          href="https://shop.trustedshops.com/de/"
          target="_blank"
          rel="noopener"
        >Trusted Shops</a>
        Rechtstexter in Kooperation mit
        <a
          title="F&Ouml;HLISCH Rechtsanw&auml;lte"
          href="https://foehlisch.com"
          target="_blank"
          rel="nofollow noopener"
        >F&Ouml;HLISCH Rechtsanw&auml;lte</a>.
      </em>
    </p>
  </div>
</template>
<script>
export default {
  name: "Wiederruftext"
};
</script>
<style lang="scss">
.legalleftborder {
  border-left: 5px solid $primary;
  padding-left: 10px;
}
</style>
